import PropTypes from 'prop-types';
import {Form, Input} from 'antd';
import {useEffect} from 'react';
import dayjs from 'dayjs';

const SingleTextLeaveDaysAttribute = ({
  attributeMetadata,
  formValues,
}) => {
  const form = Form.useFormInstance();

  const fromDate = Form.useWatch('fromDate', form);
  const toDate = Form.useWatch('toDate', form);

  useEffect(() => {
    if (fromDate && toDate) {
      const startDate = dayjs(fromDate);
      const endDate = dayjs(toDate);

      const diff = endDate.diff(startDate, 'day');

      if (diff >= 0) {
        form.setFieldsValue({
          [attributeMetadata.id]: diff + 1,
        });
      } else {
        form.setFieldsValue({
          [attributeMetadata.id]: null,
        });
      }
    } else {
      form.setFieldsValue({
        [attributeMetadata.id]: null,
      });
    }
  }, [fromDate, toDate, form, attributeMetadata.id]);

  return (
    <Form.Item
      name={attributeMetadata.id}
      label={attributeMetadata.label}
      rules={attributeMetadata.validation_rules}
    >
      <Input
        placeholder={attributeMetadata?.placeholder}
        disabled={true}
      />
    </Form.Item>
  );
};

SingleTextLeaveDaysAttribute.propTypes = {
  attributeMetadata: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    validation_rules: PropTypes.array,
    fromDate: PropTypes.string,
    toDate: PropTypes.string,
  }).isRequired,
  formValues: PropTypes.object.isRequired,
};

export default SingleTextLeaveDaysAttribute;
